
import { useState } from 'react';
import { readExcelFile } from '@/utils/excel/core/fileReader';
import { parseDistributionCenterPricesFromExcel } from '@/utils/excel/parsers/distributionCenterParser';
import { CreateDistributionCenterPriceInput } from '@/types/database/distribution-center-prices';

export const useDistributionCenterExcelParser = () => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [previewData, setPreviewData] = useState<CreateDistributionCenterPriceInput[]>([]);
  const [errors, setErrors] = useState<string[]>([]);

  const processFile = async (file: File) => {
    setIsProcessing(true);
    setPreviewData([]);
    setErrors([]);

    try {
      console.log('Processing distribution center prices file:', file.name);
      
      const workbook = await readExcelFile(file);
      const { data, errors: parseErrors } = parseDistributionCenterPricesFromExcel(workbook);
      
      console.log('Parsed distribution center prices data:', data);
      console.log('Parse errors:', parseErrors);
      
      setPreviewData(data);
      setErrors(parseErrors);
      
      return { data, errors: parseErrors };
    } catch (error) {
      console.error('Error processing distribution center prices file:', error);
      const errorMessage = error instanceof Error ? error.message : 'Failed to process file';
      setErrors([errorMessage]);
      return { data: [], errors: [errorMessage] };
    } finally {
      setIsProcessing(false);
    }
  };

  const clearData = () => {
    setPreviewData([]);
    setErrors([]);
  };

  return {
    processFile,
    clearData,
    isProcessing,
    previewData,
    errors,
    hasData: previewData.length > 0,
    hasErrors: errors.length > 0,
  };
};
